import { IFormInfo } from '../form-fileds.model';

export const HI_SAF_FORM_INFO: IFormInfo = {
  name: {
    label: 'आपका नाम',
    placeholder: 'अपना नाम दर्ज करें',
    readOnly: false,
    errMsg: {
      required: 'कृपया अपना नाम दर्ज करें',
      pattern: 'कृपया मान्य नाम दर्ज करें',
      minLength: 'नाम में कम से कम 3 अक्षर होने चाहिए'
    }
  },
  email: {
    label: 'ईमेल',
    placeholder: 'ईमेल दर्ज करें',
    readOnly: false,
    errMsg: {
      required: 'कृपया अपना ईमेल दर्ज करें',
      pattern: 'कृपया मान्य ईमेल दर्ज करें'
    }
  },
  raisingFor: {
    label: 'आप किसके लिए फंड जुटा रहे हैं?',
    placeholder: '',
    readOnly: false,
    options: [
      { value: 'self', label: 'स्वयं', icon: 'people' },
      { value: 'someoneElse', label: 'किसी और के लिए', icon: 'people' },
      { value: 'ngo', label: 'एनजीओ/चैरिटी', icon: 'people' }
    ],
    errMsg: {
      required: 'कृपया एक विकल्प चुनें'
    }
  },
  ngo: {
    label: 'एनजीओ का नाम',
    placeholder: 'नाम दर्ज करें',
    readOnly: false,
    errMsg: {
      required: 'कृपया अपना एनजीओ खोजें और चुनें',
      ngoNotFound: 'एनजीओ पंजीकृत नहीं है',
      custom: 'कृपया कोई अन्य एनजीओ चुनें'
    }
  },
  relation: {
    label: 'फंड मेरे लिए है...',
    placeholder: 'या कोई अन्य चुनें',
    readOnly: false,
    priorOptions: [
      { value: 'Mother', label: 'माँ' },
      { value: 'Father', label: 'पिता' },
      { value: 'Son', label: 'बेटा' },
      { value: 'Daughter', label: 'बेटी' },
      { value: 'Friend', label: 'दोस्त' },
    ],
    options: [
      { value: 'Aunt', label: 'चाची/मौसी' },
      { value: 'Brother', label: 'भाई' },
      { value: 'Cousin', label: 'चचेरा/ममेरा भाई/बहन' },
      { value: `Friend's Family`, label: `दोस्त का परिवार` },
      { value: 'Granddaughter', label: 'पोती/नातिन' },
      { value: 'Grandfather', label: 'दादा/नाना' },
      { value: 'Grandmother', label: 'दादी/नानी' },
      { value: 'Grandson', label: 'पोता/नाती' },
      { value: 'Husband', label: 'पति' },
      { value: 'Legal ward', label: 'कानूनी अभिभाव्य' },
      { value: 'Nephew', label: 'भतीजा/भांजा' },
      { value: 'Niece', label: 'भतीजी/भांजी' },
      { value: 'Relative', label: 'रिश्तेदार' },
      { value: 'Sister', label: 'बहन' },
      { value: 'Twins', label: 'जुड़वां' },
      { value: 'Uncle', label: 'चाचा/मामा' },
      { value: 'Wife', label: 'पत्नी' },
      { value: 'Pet', label: 'पालतू' },
      { value: 'Other', label: 'अन्य' },
    ],
    errMsg: {
      required: 'कृपया एक विकल्प चुनें'
    }
  },
  beneficiaryName: {
    label: 'लाभार्थी का नाम',
    placeholder: 'लाभार्थी का नाम दर्ज करें',
    readOnly: false,
    errMsg: {
      required: 'कृपया लाभार्थी का नाम दर्ज करें',
      pattern: 'कृपया मान्य नाम दर्ज करें',
      minLength: 'नाम में कम से कम 3 अक्षर होने चाहिए'
    }
  },
  age: {
    label: 'आयु वर्ग?',
    options: [
      { value: '0-5', label: '0-5 वर्ष', icon: 'person' },
      { value: '5-18', label: '5-18 वर्ष', icon: 'person' },
      { value: '18-60', label: '18-60 वर्ष', icon: 'person' },
      { value: '60+', label: '60+ वर्ष', icon: 'person' },
    ],
    errMsg: {
      required: 'कृपया एक विकल्प चुनें'
    }
  },
  fundRequired: {
    label: 'आप कितना धन जुटाना चाहते हैं?',
    prefix: '₹',
    placeholder: '000000',
    readOnly: false,
    note: 'आप अभी एक अनुमानित राशि डाल सकते हैं और बाद में इसे बदल सकते हैं। न्यूनतम ₹2000 होना चाहिए',
    errMsg: {
      required: 'कृपया राशि दर्ज करें',
      min: 'कृपया ₹2000 या उससे अधिक राशि दर्ज करें',
      max: 'कृपया ₹5,00,00,000 से कम या बराबर राशि दर्ज करें'
    }
  },
  cause: {
    label: 'आपके फंडरेज़र का उद्देश्य इनमें से कौन सा है?',
    readOnly: false,
    showMore: 'और कारण देखें',
    showLess: 'कम कारण देखें',
    errMsg: {
      required: 'कृपया एक विकल्प चुनें'
    }
  },
  ailment: {
    label: 'बीमारी / चिकित्सा स्थिति',
    placeholder: 'खोजें और विकल्प चुनें',
    readOnly: false,
    errMsg: {
      required: 'कृपया दर्ज करें और विकल्प चुनें'
    }
  },
  hospitalisation: {
    label: 'आपकी अस्पताल में भर्ती स्थिति क्या है?',
    readOnly: false,
    options: [
      {
        value: 'Recently discharged from the hospital',
        label: 'हाल ही में छुट्टी मिली है',
        icon: 'people',
      },
      {
        value: 'Currently hospitalised',
        label: 'फिलहाल भर्ती हैं',
        icon: 'people',
      },
      {
        value: 'Will be hospitalised soon',
        label: 'जल्द ही भर्ती होंगे',
        icon: 'people',
      },
    ],
    lowPriorOptions: [
      {
        value: 'Does not require hospitalisation',
        label: 'अस्पताल में भर्ती की आवश्यकता नहीं है',
        icon: 'block',
      },
    ],
    errMsg: {
      required: 'कृपया एक विकल्प चुनें'
    }
  },
  hospital: {
    label: 'अस्पताल का नाम',
    placeholder: 'अस्पताल चुनें',
    readOnly: false,
    errMsg: {
      required: 'कृपया अस्पताल चुनें'
    }
  },
  sameCityAsHospital: {
    label: 'मैं अस्पताल के शहर में हूं',
    readOnly: false
  },
  city: {
    label: 'शहर',
    placeholder: 'शहर दर्ज करें',
    readOnly: false,
    errMsg: {
      required: 'कृपया शहर दर्ज करें',
      custom: 'कृपया एक वैध शहर चुनें'
    }
  },
  title: {
    label: 'फंडरेज़र का शीर्षक',
    placeholder: 'शीर्षक दर्ज करें',
    readOnly: false,
    errMsg: {
      required: 'कृपया शीर्षक दर्ज करें',
      minLength: 'न्यूनतम 5 अक्षर आवश्यक',
      maxLength: 'अधिकतम 75 अक्षर अनुमत हैं'
    }
  },
  about: {
    label: 'हमने आपकी कहानी लिखी है—कभी भी संपादित करें',
    label1: 'समझाएं कि यह फंडरेज़र आपके लिए महत्वपूर्ण क्यों है।',
    label2: 'अपनी कहानी बताएं',
    placeholder: 'एक ऐसी कहानी लिखें जो आपके उद्देश्य के साथ न्याय करे और दानदाता को योगदान देने के लिए प्रेरित करे।',
    readOnly: false,
    errMsg: {
      required: 'फ़ील्ड आवश्यक है',
      minLength: 'न्यूनतम 50 अक्षर आवश्यक'
    }
  },
  aboutMerge: {
    label: 'फंड का उपयोग किसके लिए किया जाएगा?',
    placeholder: 'ट्यूशन, यात्रा, किताबें आदि',
    readOnly: false,
    errMsg: {
      required: 'कृपया उपयोग का कारण दर्ज करें'
    }
  },
  media: {
    label: `अपने उद्देश्य का समर्थन करने के लिए फोटो अपलोड करें <span class="optional">(वैकल्पिक)</span>`,
    readOnly: false
  },

  insuranceOptIn: {
    label: `मैं अपनी पसंद के परिवार के सदस्य के लिए <strong>₹1.2 लाख बीमा कवर</strong> हेतु धन जुटाने के लिए सहमति देता हूँ।`,
    readOnly: false,
  },
  agree: {
    label: `मैं केट्टो के <a href="{{terms}}" target="_blank">उपयोग की शर्तों</a>, <a href="{{privacy}}" target="_blank">गोपनीयता नीति</a> और <a href="{{plans}}" target="_blank">योजनाएं और मूल्य निर्धारण</a> से सहमत हूं। मैं स्वीकार करता/करती हूं कि उपरोक्त दी गई जानकारी मेरी जानकारी और विश्वास के अनुसार सही है। यदि दी गई जानकारी झूठी या भ्रामक पाई जाती है, तो मैं जिम्मेदार रहूंगा/रहूंगी। मैं इसे नियामक अधिकारियों के साथ साझा करने या कानून के अनुसार खुलासा करने की अपनी सहमति देता/देती हूं।`,
    readOnly: false,
    errMsg: {
      required: 'कृपया सहमति पढ़ें और चुनें'
    }
  }
};

export const HI_OTHER_INFO = {
  verifyEmail: {
    title: 'एक बार पुष्टि हो जाने के बाद आप ईमेल नहीं बदल सकते',
    confirm: 'पुष्टि करें',
    edit: 'संपादित करें'
  },
  verifyEmailOTP: {
    title: `ईमेल पर भेजा गया OTP दर्ज करें`,
    confirm: 'सत्यापित करें',
    edit: 'ईमेल संपादित करें'
  }
};
